import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import MESSAGES from 'core/data-model/constants/messages'
import FundSummary from 'quick-quote/product-investment/fund-allocation/components/fund-summary'
import AllocationPart from 'quick-quote/product-investment/fund-allocation/lstu/components/allocation-part'

import { InsuredInformationBreadcrumb } from '../../../components'

const FundAllocationComponent = ({
  navTabList,
  funds,
  allocations,
  totalAllocation,
  toggleFundAllocation,
  calculateTotalFundAllocation,
  resetFundAllocations,
  allowHigherRiskInvestment,
  allowForeignInvestment,
  isLowRiskEvaluated,
  hasValidEntryComponent,
  onAllocateSameAsRPP,
  onAllocateIndependently,
  chosenOption,
  hasAcceptedFundAllocation,
  fundSummary,
  isAcceptedOverRisk,
  isAcceptedForeign,
  onAcceptHigherRiskInvestment,
  onAcceptForeignInvestment,
  foreignExchangingQuestion,
  resetLstuAcceptFundAllocation,
}) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [hasAcceptedFundAllocation])
  const goToRPQAndRetest = () => {
    const RPQTab = navTabList.find((tab) => tab.id === 'invest')
    const history = useHistory()
    if (RPQTab) history.push(RPQTab.path)
  }
  return (
    <div id="lstu-fund-allocation" className="fund-allocation">
      <InsuredInformationBreadcrumb />
      <div className="content">
        {!hasAcceptedFundAllocation ? (
          <AllocationPart
            funds={funds}
            allocations={allocations}
            totalAllocation={totalAllocation}
            toggleFundAllocation={toggleFundAllocation}
            calculateTotalFundAllocation={calculateTotalFundAllocation}
            resetFundAllocations={resetFundAllocations}
            allowHigherRiskInvestment={allowHigherRiskInvestment}
            allowForeignInvestment={allowForeignInvestment}
            isLowRiskEvaluated={isLowRiskEvaluated}
            hasValidEntryComponent={hasValidEntryComponent}
            onAllocateSameAsRPP={onAllocateSameAsRPP}
            onAllocateIndependently={onAllocateIndependently}
            chosenOption={chosenOption}
            onRetakeRPQ={goToRPQAndRetest}
          />
        ) : (
          <FundSummary
            fundSummaryTitile={MESSAGES.LSTU_SUMMARY_FUND_TITLE}
            allocations={fundSummary}
            isAcceptOverRisk={isAcceptedOverRisk}
            isAcceptForeign={isAcceptedForeign}
            rppAcceptHigherRiskInvestment={onAcceptHigherRiskInvestment}
            rppAcceptForeignInvestment={onAcceptForeignInvestment}
            resetRppAcceptFundAllocation={resetLstuAcceptFundAllocation}
            foreignExchangingQuestion={foreignExchangingQuestion}
          />
        )}
      </div>
    </div>
  )
}

FundAllocationComponent.displayName = 'FundAllocation'

export const FundAllocation = FundAllocationComponent
